"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalAggregatedLiquidityStatsSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.HistoricalAggregatedLiquidityStatsSchema = zod_1.z.object({
    totalEmission: core_contracts_ifaces_1.TokenAmountSchema,
    currentEpochEmission: core_contracts_ifaces_1.TokenAmountSchema,
    currentDailyEmission: core_contracts_ifaces_1.TokenAmountSchema,
});
